import React, { useEffect, useState } from "react";
import Clessidra from './Clessidra';
import "./ContenutoImmagineVideo.css";

export default function ContenutoImmagineVideo(props) {
  const [flagCaricato, setFlagCaricato] = useState(false);
  const larghezzaImmagini = 560;
  const proporzioneLarghezzaAltezzaImmagini = 2;

  let larghezza = larghezzaImmagini;
  if (props.dimensioniApp.flagPaginaOrizzontale) {
    if (larghezza > (props.dimensioniApp.x - 80) / 2) {
      larghezza = (props.dimensioniApp.x - 80) / 2;
    }
  } else {
    if (larghezza > props.dimensioniApp.x - 120) {
      larghezza = props.dimensioniApp.x - 120;
    }
  }

  const altezza = larghezza / proporzioneLarghezzaAltezzaImmagini;

  if (props.urlContenuto) {
    if (props.tipoContenuto === "mp4") {
      return (
        <div className="mockup" style={{ maxWidth: 500, width: '90%', maxHeight: 300 }}>
          <video
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",     // 👍 fa adattare il contenuto
              opacity: flagCaricato ? 1 : 0,
              transition: "opacity 1s"
            }}
            onLoadedData={() => setFlagCaricato(true)}
            autoPlay
            loop
            muted
            playsInline
            loading="lazy"
          >
            <source src={props.urlContenuto} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {!flagCaricato && <Clessidra top={-altezza / 1.5} loading={true} />}
        </div>
      );
    }

    if (props.tipoContenuto === "jpg" || props.tipoContenuto === "png") {
      return (
        <div className="mockup" style={{ maxWidth: 500, width: '90%', maxHeight: 300 }}>
          <img
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              opacity: flagCaricato ? 1 : 0,
              transition: "opacity 1s"
            }}
            onLoad={() => setFlagCaricato(true)}
            src={props.urlContenuto}
            alt="immagine"
            loading="lazy"
          />
          {!flagCaricato && <Clessidra top={-altezza / 1.5} loading={true} />}
        </div>
      );
    }
  }

  return <></>;
}
